export default __webpack_public_path__ + "static/qrCode-ab7204c249e3e9fe99422d0f2914a8f7.png";